/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RenderedStepWarning } from './renderedStepWarning';

export interface RenderedStepPreview {
  rendered_html?: string | null;
  rendered_text: string;
  subject?: string | null;
  attachments?: string[];
  warnings?: RenderedStepWarning[];
  tokens_used?: number;
  sender_name?: string | null;
  sender_avatar_url?: string | null;
}
